import AutoAwesome from "@mui/icons-material/AutoAwesome";
import { IconButton, Tooltip } from "@mui/material";
import { useCallback, useState } from "react";

import { useScoutSkillsLibraryEnabled } from "../useScoutSkillsLibraryEnabled";
import { ManageSkillsDialog } from "./ManageSkillsDialog";

type ManageSkillsButtonProps = {
  disabled?: boolean;
  iconButtonSize?: "small" | "medium" | "large";
};

/** Temporary header entry for Manage Skills (settings menu was removed). */
export function ManageSkillsButton({
  disabled = false,
  iconButtonSize = "small",
}: ManageSkillsButtonProps) {
  const skillsLibraryEnabled = useScoutSkillsLibraryEnabled();
  const [manageSkillsOpen, setManageSkillsOpen] = useState(false);

  const handleOpen = useCallback(() => {
    if (!skillsLibraryEnabled || disabled) {
      return;
    }
    setManageSkillsOpen(true);
  }, [disabled, skillsLibraryEnabled]);

  if (!skillsLibraryEnabled) {
    return null;
  }

  return (
    <>
      <Tooltip title="Manage Skills">
        <span>
          <IconButton
            size={iconButtonSize}
            onClick={handleOpen}
            disabled={disabled}
            aria-label="Manage Skills"
          >
            <AutoAwesome fontSize={iconButtonSize} />
          </IconButton>
        </span>
      </Tooltip>
      {manageSkillsOpen ? (
        <ManageSkillsDialog open onClose={() => setManageSkillsOpen(false)} />
      ) : null}
    </>
  );
}
